import styled from "styled-components";

export const H2 = styled.h2`
  margin: 24px 0 14px 0;
  font-size: 24px;
`;

export const H3 = styled.h3`
  margin: 20px 0 10px 0;
  font-size: 20px;
`;
